import N8nToggleGroup from './ToggleGroup.vue';

export default N8nToggleGroup;
